export const V3IconProfileCollectionsTabsLayout = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
        <rect width="5" height="12" x="2" y="6" stroke="#ABB0BA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" rx=".5" />
        <rect width="5" height="16" x="9.5" y="4" stroke="#ABB0BA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" rx=".5" />
        <rect width="5" height="12" x="17" y="6" stroke="#ABB0BA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" rx=".5" />
    </svg>
);
